import { getCookie } from '../../common/cookies'

const initStrip = () => {
  const contentStrip = document.getElementById('content-strip')
  const footer = document.querySelector('#footer')
  const closeStripBtn = document.getElementById('close-strip')
  const isAcceptedCookie = getCookie('closeStrip')

  const setCookie = (name, lifeTimeHours = 0) => {
    if (contentStrip) {
      contentStrip.classList.remove('show')
      footer.classList.remove('strip-footer')
    }

    const now = new Date()
    now.setTime(now.getTime() + lifeTimeHours * 3600 * 1000)

    if (lifeTimeHours > 0) {
      document.cookie = `${name}=accepted; expires=${now.toUTCString()}; path=/;`
    } else {
      document.cookie = `${name}=accepted; path=/;`
    }
  }

  if (contentStrip) {
    contentStrip.classList.add('show')
    footer.classList.add('strip-footer')
  }

  if (isAcceptedCookie && contentStrip) {
    contentStrip.classList.remove('show')
    footer.classList.remove('strip-footer')
  }

  if (closeStripBtn) {
    closeStripBtn.addEventListener('click', () => {
      setCookie('closeStrip', 24)
    })
  }
}

export default initStrip
